import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export const CareersSection = () => {
  return (
    <section id="careers" className="py-20 px-4 section-dark">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-8 text-white">
          We're <span className="text-[#ffa05d]">hiring</span>
        </h2>

        <p className="text-lg text-white/70 mb-10 max-w-3xl mx-auto">
          If you're excited by what AI and audio can unlock for human health, we'd love to hear from you.
        </p>

        <Button
          asChild
          size="lg"
          className="bg-[#ffa05d] hover:bg-[#ffa05d]/90 text-white group"
        >
          <a
            href="https://complete-silene-521.notion.site/3028781d053880bcbb1ede05f3e4768d?v=3028781d053880f1be42000c38d64d18&source=copy_link"
            target="_blank"
            rel="noopener noreferrer"
          >
            View open roles
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </a>
        </Button>
      </div>
    </section>
  );
};
